import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { WaitlistEntryUpdateModal } from './WaitlistEntryUpdateModal';

type WaitlistEntryUpdateModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type WaitlistEntryUpdateModalOpenerProps = {
   children: (renderProps: WaitlistEntryUpdateModalOpenerChildrenRenderProps) => ReactElement;
   waitlistEntry: WaitlistEntry;
};

export const WaitlistEntryUpdateModalOpener = (props: WaitlistEntryUpdateModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <WaitlistEntryUpdateModal onClose={closeModal} waitlistEntry={props.waitlistEntry} /> : null}
      </>
   );
};
